import "./index.sass";

const HeaderRight = () => {
  return <div className="header-right"> </div>;
};

export default HeaderRight;
